import type { ReactNode } from 'react';
import { ProfileUserCard } from './ProfileUserCard';
import type { ProfileDisplayUser } from './types';

interface ProfileLayoutProps {
  user: ProfileDisplayUser | undefined;
  children: ReactNode;
}

export function ProfileLayout({ user, children }: ProfileLayoutProps) {
  return (
    <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
      <div className="shrink-0 lg:w-72 xl:w-80">
        <ProfileUserCard user={user} />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-6">{children}</div>
    </div>
  );
}
